import http from './http'

export const getEasyPayRechargeRecords = (params) => {
  return http.post('/easyPayRecharge/rechargeRecords', params)
}

export const getUsdtRechargeRecords = (params) => {
  return http.post('/usdtRecharge/rechargeRecords', params)
}